<ng-container *ngIf="(layout | async) === 3">
    <!-- <ng-container *ngIf="'desktop' | mediaQuery"> -->
    <div class="col-xs-4 sp-0">
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.supplier.card" ttHeading="h_supplier" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="supplier"></ng-container>
        </tt-card>
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.receiver.card" ttHeading="h_receiver" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="reciever"></ng-container>
        </tt-card>
    </div>

    <div class="col-xs-4 sp-0">
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.delivery.card" ttHeading="h_delivery" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="delivery"></ng-container>
        </tt-card>
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.economy.card" ttHeading="h_economy" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="economy"></ng-container>
        </tt-card>
        <tt-card ttRememberId="w_purchhead.freight.card" [hidden]="get.show_freightrateset === '0'" class="col-xs-12 p-5" ttHeading="h_freight" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="freight"></ng-container>
        </tt-card>
    </div>

    <div class="col-xs-4 sp-0">
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.admin.card" ttHeading="h_admin" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="admin"></ng-container>
        </tt-card>
        <ng-container *ngTemplateOutlet="submit"></ng-container>
    </div>
</ng-container>

<ng-container *ngIf="(layout | async) === 2">
    <!-- <ng-container *ngIf="'laptop' | mediaQuery"> -->
    <div class="col-xs-6 sp-0">
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.supplier.card" ttHeading="h_supplier" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="supplier"></ng-container>
        </tt-card>
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.receiver.card" ttHeading="h_receiver" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="reciever"></ng-container>
        </tt-card>
        <tt-card ttRememberId="w_purchhead.freight.card" [hidden]="get.show_freightrateset === '0'" class="col-xs-12 p-5" ttHeading="h_freight" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="freight"></ng-container>
        </tt-card>
        <ng-container *ngTemplateOutlet="submit"></ng-container>
    </div>

    <div class="col-xs-6 sp-0">
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.delivery.card" ttHeading="h_delivery" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="delivery"></ng-container>
        </tt-card>
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.economy.card" ttHeading="h_economy" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="economy"></ng-container>
        </tt-card>
        <tt-card class="col-xs-12 p-5" ttRememberId="w_purchhead.admin.card" ttHeading="h_admin" ttAccordion *ngIf="!!get">
            <ng-container *ngTemplateOutlet="admin"></ng-container>
        </tt-card>
    </div>
</ng-container>

<ng-container *ngIf="(layout | async) === 1">
    <!-- <ng-container *ngIf="(['mobile', 'tablet'] | mediaQuery) && !!get"> -->
    <tt-tabs #headTabs>
        <tt-tab ttId="ADDRESS" ttLabel="purchhead_address"></tt-tab>
        <tt-tab ttId="TERMS" ttLabel="purchhead_terms"></tt-tab>
        <tt-tab ttId="STAT" ttLabel="purchhead_stat"></tt-tab>
    </tt-tabs>
    <div [hidden]="headTabs.ttSelectedId !== 'ADDRESS'">
        <tt-tabs #addressTabs>
            <tt-tab ttId="SUPPLIER" ttLabel="purchhead_gb_address_supplier"></tt-tab>
            <tt-tab ttId="RECEIVER" ttLabel="purchhead_gb_address_receiver"></tt-tab>
        </tt-tabs>
        <div [hidden]="addressTabs.ttSelectedId !== 'SUPPLIER'">
            <tt-card class="col-xs-12 p-5" ttHeading="h_supplier" *ngIf="!!get">
                <ng-container *ngTemplateOutlet="supplier"></ng-container>
            </tt-card>
        </div>
        <div [hidden]="addressTabs.ttSelectedId !== 'RECEIVER'">
            <tt-card class="col-xs-12 p-5" ttHeading="h_receiver" *ngIf="!!get">
                <ng-container *ngTemplateOutlet="reciever"></ng-container>
            </tt-card>
        </div>
    </div>
    <div [hidden]="headTabs.ttSelectedId !== 'TERMS'">
        <tt-tabs #termsTabs>
            <tt-tab ttId="DELIVERY" ttLabel="purchhead_gb_terms_delivery"></tt-tab>
            <tt-tab ttId="ECONOMY" ttLabel="purchhead_gb_terms_economy"></tt-tab>
            <tt-tab ttId="OTHER" ttLabel="purchhead_gb_terms_other"></tt-tab>
        </tt-tabs>
        <div [hidden]="termsTabs.ttSelectedId !== 'OTHER'">
            <tt-card [hidden]="get.show_freightrateset === '0'" class="col-xs-12 p-5" ttHeading="h_freight" *ngIf="!!get">
                <ng-container *ngTemplateOutlet="freight"></ng-container>
            </tt-card>
        </div>
        <div [hidden]="termsTabs.ttSelectedId !== 'DELIVERY'">
            <tt-card class="col-xs-12 p-5" ttHeading="h_delivery" *ngIf="!!get">
                <ng-container *ngTemplateOutlet="delivery"></ng-container>
            </tt-card>
        </div>
        <div [hidden]="termsTabs.ttSelectedId !== 'ECONOMY'">
            <tt-card class="col-xs-12 p-5" ttHeading="h_economy" *ngIf="!!get">
                <ng-container *ngTemplateOutlet="economy"></ng-container>
            </tt-card>
        </div>
    </div>
    <div [hidden]="headTabs.ttSelectedId !== 'STAT'">
        <tt-card class="col-xs-12 p-5" ttHeading="h_admin" *ngIf="!!get">
            <ng-container *ngTemplateOutlet="admin"></ng-container>
        </tt-card>
    </div>
    <ng-container *ngTemplateOutlet="submit"></ng-container>
</ng-container>

<ng-template #submit>
    <tt-card class="col-xs-12 p-5" *ngIf="get?.ischanged === '1'">
        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</ng-template>

<ng-template #supplier>
    <ng-container *ngIf="!!get">
        <tt-input *ngIf="get.setting_show_ph_head_supplier_no !== '0'" ttLabel="supplier_no" [ttModel]="get.supplier_no" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button
                    ttId="new"
                    ttIcon="fas fa-plus"
                    ttGoto="customeredit"
                    [ttGotoParms]="{ cust_no: '0' }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_new_customer"
                ></tt-form-field-button>
                <tt-form-field-button
                    ttId="edit"
                    ttIcon="fas fa-pen"
                    ttGoto="customeredit"
                    [ttGotoParms]="{ cust_no: '' + this.get.supplier_no }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_customeredit"
                ></tt-form-field-button>
                <tt-form-field-button
                    ttId="new"
                    ttIcon="fas fa-chevron-right"
                    ttGoto="customersmenu"
                    [ttGotoParms]="{ cust_no: '' + this.get.supplier_no }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_customersmenu"
                ></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-input *ngIf="get.setting_show_ph_head_supplier_name !== '0'" ttLabel="supplier_name" [ttModel]="get.supplier_name" ttReadonly></tt-input>
        <tt-textarea *ngIf="get.setting_show_ph_head_supplier_address !== '0'" ttLabel="supplier_address" [ttModel]="get.supplier_address" ttReadonly></tt-textarea>
        <tt-select
            *ngIf="get.setting_show_ph_head_supplier_pers_no !== '0'"
            ttLabel="supplier_pers_no"
            [(ttModel)]="get.supplier_pers_no"
            (ttModelChange)="onSupplierPersNoChanged()"
            [ttData]="customerPersons"
            [ttShowClearButton]="get.supplier_pers_no > '0'"
        >
            <ng-container buttons>
                <tt-form-field-button
                    ttId="goto"
                    ttIcon="fas fa-chevron-right"
                    ttGoto="customerpersons"
                    [ttGotoParms]="'' + get.supplier_no"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_customerpersons"
                ></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-input *ngIf="get.setting_show_ph_head_label !== '0'" ttLabel="label" [(ttModel)]="get.label" (ttModelChange)="onCommonChange($event, 'label')"></tt-input>
        <ng-container *ngIf="get.supplier_pers_no > '0'">
            <tt-input *ngIf="get.setting_show_ph_head_supplier_pers_telephone !== '0'" ttLabel="supplier_pers_telephone" [ttModel]="get.supplier_pers_telephone" ttReadonly></tt-input>
            <tt-input *ngIf="get.setting_show_ph_head_supplier_pers_email !== '0'" ttLabel="supplier_pers_email" [ttModel]="get.supplier_pers_email" ttReadonly></tt-input>
        </ng-container>
        <tt-input *ngIf="get.setting_show_ph_head_suppliers_orderno !== '0'" ttLabel="suppliers_orderno" [(ttModel)]="get.suppliers_orderno" (ttModelChange)="onCommonChange($event, 'suppliers_orderno')"></tt-input>

        <tt-input *ngIf="get.setting_show_ph_head_project_name !== '0'" ttLabel="project_name" [ttModel]="get.project_name" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-search" (ttClick)="openSelectProject()" [ttTranslateTooltip]="true" ttTooltip="goto_selectproject"></tt-form-field-button>
                <tt-form-field-button
                    *ngIf="get.project_keyno > '0'"
                    ttIcon="fas fa-chevron-right"
                    ttGoto="projectmenu"
                    [ttGotoParms]="{ project_keyno: '' + get.project_keyno }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_projectmenu"
                ></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-textarea *ngIf="get.setting_show_ph_head_message_to_supplier !== '0'" ttLabel="message_to_supplier" [(ttModel)]="get.message_to_supplier" (ttModelChange)="onCommonChange($event, 'message_to_supplier')"></tt-textarea>
    </ng-container>
</ng-template>

<ng-template #reciever>
    <ng-container *ngIf="!!get">
        <tt-select *ngIf="get.show_department_id !== '0'" ttLabel="department" [(ttModel)]="get.department_id" (ttModelChange)="onDepartmentIdChanged()" [ttData]="departments" ttDataId="department_id" ttDataName="department_name">
            <ng-container buttons>
                <tt-form-field-button ttId="list" ttIcon="fas fa-bars" ttGoto="departments" [ttTranslateTooltip]="true" ttTooltip="goto_departments"></tt-form-field-button>
                <tt-form-field-button
                    *ngIf="get.department_id > ''"
                    ttId="goto"
                    ttIcon="fas fa-chevron-right"
                    ttGoto="department"
                    [ttGotoParms]="{ department_id: get.department_id }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_department"
                ></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-checkbox *ngIf="get.setting_show_ph_head_delivery_cust_unreg !== '0'" ttLabel="delivery_cust_unreg" [(ttModel)]="get.delivery_cust_unreg" (ttModelChange)="onCommonChange($event, 'delivery_cust_unreg')"></tt-checkbox>
        <div [hidden]="get.delivery_cust_unreg === '1'">
            <tt-input *ngIf="get.setting_show_ph_head_delivery_cust_no !== '0'" ttLabel="delivery_cust_no" [ttModel]="get.delivery_cust_no" ttReadonly>
                <ng-container buttons>
                    <tt-form-field-button
                        ttId="new"
                        ttIcon="fas fa-plus"
                        ttGoto="customeredit"
                        [ttGotoParms]="{ cust_no: '0' }"
                        [ttTranslateTooltip]="true"
                        ttTooltip="goto_new_customer"
                    ></tt-form-field-button>
                    <tt-form-field-button
                        ttId="edit"
                        ttIcon="fas fa-pen"
                        ttGoto="customeredit"
                        [ttGotoParms]="{ cust_no: '' + this.get.delivery_cust_no }"
                        [ttTranslateTooltip]="true"
                        ttTooltip="goto_customeredit"
                    ></tt-form-field-button>
                    <tt-form-field-button
                        ttId="new"
                        ttIcon="fas fa-chevron-right"
                        ttGoto="customersmenu"
                        [ttGotoParms]="{ cust_no: '' + this.get.delivery_cust_no }"
                        [ttTranslateTooltip]="true"
                        ttTooltip="goto_customersmenu"
                    ></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-input *ngIf="get.setting_show_ph_head_delivery_name !== '0'" ttLabel="purchhead_delivery_name" [ttModel]="get.delivery_name" ttReadonly></tt-input>
            <tt-input *ngIf="get.setting_show_ph_head_delivery_address !== '0'" ttLabel="delivery_address" [ttModel]="get.delivery_address" ttReadonly></tt-input>
        </div>
        <div [hidden]="get.delivery_cust_unreg === '0'">
            <tt-input *ngIf="get.setting_show_ph_head_delivery_cust_name !== '0'" ttLabel="delivery_cust_name" [(ttModel)]="get.delivery_cust_name" (ttModelChange)="onCommonChange($event, 'delivery_cust_name')"></tt-input>
            <tt-input *ngIf="get.setting_show_ph_head_delivery_adr_street !== '0'" ttLabel="delivery_adr_street" [(ttModel)]="get.delivery_adr_street" (ttModelChange)="onCommonChange($event, 'delivery_adr_street')"></tt-input>
            <tt-input
                *ngIf="get.setting_show_ph_head_delivery_postplace_id_street !== '0'"
                ttLabel="delivery_postplace_id_street"
                [(ttModel)]="get.delivery_postplace_id_street"
                (ttModelChange)="onCommonChange($event, 'delivery_postplace_id_street')"
            ></tt-input>
            <tt-input
                *ngIf="get.setting_show_ph_head_delivery_postplace_name_street !== '0'"
                ttLabel="delivery_postplace_name_street"
                [(ttModel)]="get.delivery_postplace_name_street"
                (ttModelChange)="onCommonChange($event, 'delivery_postplace_name_street')"
            ></tt-input>
            <tt-select
                *ngIf="get.setting_show_ph_head_delivery_country_id !== '0'"
                ttLabel="delivery_country_id"
                [(ttModel)]="get.delivery_country_id"
                (ttModelChange)="onCommonChange($event, 'delivery_country_id')"
                [ttData]="countries"
                ttDataId="country_id"
                ttDataName="country_name"
            ></tt-select>
            <tt-input *ngIf="get.setting_show_ph_head_delivery_adr_mail !== '0'" ttLabel="delivery_adr_mail" [(ttModel)]="get.delivery_adr_mail" (ttModelChange)="onCommonChange($event, 'delivery_adr_mail')"></tt-input>
            <tt-input *ngIf="get.setting_show_ph_head_delivery_postplace_id !== '0'" ttLabel="delivery_postplace_id" [(ttModel)]="get.delivery_postplace_id" (ttModelChange)="onCommonChange($event, 'delivery_postplace_id')"></tt-input>
            <tt-input *ngIf="get.setting_show_ph_head_delivery_postplace_name !== '0'" ttLabel="delivery_postplace_name" [(ttModel)]="get.delivery_postplace_name" (ttModelChange)="onCommonChange($event, 'delivery_postplace_name')"></tt-input>
        </div>
    </ng-container>
</ng-template>

<ng-template #freight>
    <ng-container *ngIf="!!get">
        <form name="test_form">
            <tt-select
                *ngIf="get.setting_show_ph_head_freightrateset_keyno !== '0'"
                ttLabel="freightrateset"
                [(ttModel)]="get.freightrateset_keyno"
                (ttModelChange)="onFreightRateSetKeynoChanged()"
                [ttData]="freightRateSets"
                ttDataId="freightrateset_keyno"
                ttDataName="freightrateset_name"
            >
                <ng-container buttons>
                    <tt-form-field-button
                        ttId="goto"
                        ttIcon="fas fa-chevron-right"
                        [ttBeforeGoto]="save"
                        ttGoto="freightratesets"
                        [ttGotoParms]="{ cust_no: '' + get.supplier_no }"
                        [ttTranslateTooltip]="true"
                        ttTooltip="goto_freightratesets"
                    ></tt-form-field-button>
                </ng-container>
            </tt-select>
            <tt-select
                *ngIf="get.setting_show_ph_head_freightrate_keyno !== '0'"
                ttLabel="freightrate"
                [(ttModel)]="get.freightrate_keyno"
                (ttModelChange)="onFreightRateKeynoChanged()"
                [ttData]="freightRates"
                ttDataId="freightrate_keyno"
                ttDataName="freightratetype_name"
            ></tt-select>
            <tt-select *ngIf="get.setting_show_ph_head_deliveryterm_no !== '0'" ttLabel="deliveryterm_no" [(ttModel)]="get.deliveryterm_no" (ttModelChange)="onCommonChange($event, 'deliveryterm_no')" [ttData]="deliveryTerms"></tt-select>
            <tt-checkbox *ngIf="get.setting_show_ph_head_freightrates_changed !== '0'" ttLabel="freightrates_changed" [(ttModel)]="get.freightrates_changed" (ttModelChange)="onCommonChange($event, 'freightrates_changed')"></tt-checkbox>
            <ng-container *ngIf="get.freightrates_changed === '0'">
                <tt-input-number *ngIf="get.setting_show_ph_head_freight_main_rate_locval !== '0'" ttLabel="freight_main_rate_locval" [ttModel]="get.freight_main_rate_locval" ttTextAlign="right" ttDecimals="2" ttFormatNumber ttReadonly></tt-input-number>
                <tt-input-number *ngIf="get.setting_show_ph_head_freight_last_rate_locval !== '0'" ttLabel="freight_last_rate_locval" [ttModel]="get.freight_last_rate_locval" ttTextAlign="right" ttDecimals="2" ttFormatNumber ttReadonly></tt-input-number>
                <tt-input-number *ngIf="get.setting_show_ph_head_customs_last_rate_locval !== '0'" ttLabel="customs_last_rate_locval" [ttModel]="get.customs_last_rate_locval" ttTextAlign="right" ttDecimals="2" ttFormatNumber ttReadonly></tt-input-number>
            </ng-container>
            <ng-container *ngIf="get.freightrates_changed === '1'">
                <tt-input-number
                    *ngIf="get.setting_show_ph_head_freight_main_rate_locval !== '0'"
                    ttLabel="freight_main_rate_locval"
                    [(ttModel)]="get.freight_main_rate_locval"
                    (ttModelChange)="onCommonChange($event, 'freight_main_rate_locval')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttFormatNumber
                ></tt-input-number>
                <tt-input-number
                    *ngIf="get.setting_show_ph_head_freight_last_rate_locval !== '0'"
                    ttLabel="freight_last_rate_locval"
                    [(ttModel)]="get.freight_last_rate_locval"
                    (ttModelChange)="onCommonChange($event, 'freight_last_rate_locval')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttFormatNumber
                ></tt-input-number>
                <tt-input-number
                    *ngIf="get.setting_show_ph_head_customs_last_rate_locval !== '0'"
                    ttLabel="customs_last_rate_locval"
                    [(ttModel)]="get.customs_last_rate_locval"
                    (ttModelChange)="onCommonChange($event, 'customs_last_rate_locval')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttFormatNumber
                ></tt-input-number>
            </ng-container>
            <tt-button ttText="purchhead_update_freight" ttIcon="fas fa-sync-alt" (ttClick)="updateFreight()" [ttLoading]="updatingFreight"></tt-button>
        </form>
    </ng-container>
</ng-template>

<ng-template #delivery>
    <ng-container *ngIf="!!get">
        <tt-date
            *ngIf="get.setting_show_ph_head_deliverydate_exfactory_requested !== '0'"
            ttLabel="deliverydate_exfactory_requested"
            [(ttModel)]="get.deliverydate_exfactory_requested"
            (ttModelChange)="onCommonChange($event, 'deliverydate_exfactory_requested')"
            ttAllowEmpty
        ></tt-date>
        <tt-input *ngIf="get.setting_show_ph_head_shipment_id !== '0'" ttLabel="shipment_id" [(ttModel)]="get.shipment_id" (ttModelChange)="onCommonChange($event, 'shipment_id')"></tt-input>
        <tt-input *ngIf="get.setting_show_ph_head_container_id !== '0'" ttLabel="container_id" [(ttModel)]="get.container_id" (ttModelChange)="onCommonChange($event, 'container_id')"></tt-input>
        <tt-date
            *ngIf="get.setting_show_ph_head_deliverydate_exfactory_confirmed !== '0'"
            ttLabel="deliverydate_exfactory_confirmed"
            [(ttModel)]="get.deliverydate_exfactory_confirmed"
            (ttModelChange)="onCommonChange($event, 'deliverydate_exfactory_confirmed')"
            ttAllowEmpty
        ></tt-date>
        <tt-date
            *ngIf="get.setting_show_ph_head_deliverydate_exfactory_shipped !== '0'"
            ttLabel="deliverydate_exfactory_shipped"
            [(ttModel)]="get.deliverydate_exfactory_shipped"
            (ttModelChange)="onCommonChange($event, 'deliverydate_exfactory_shipped')"
            ttAllowEmpty
        ></tt-date>
        <tt-date *ngIf="get.setting_show_ph_head_deliverydate_wish !== '0'" ttLabel="deliverydate_wish" [(ttModel)]="get.deliverydate_wish" (ttModelChange)="onCommonChange($event, 'deliverydate_wish')" ttAllowEmpty></tt-date>
        <tt-input *ngIf="get.setting_show_ph_head_deliverydate_text !== '0'" ttLabel="deliverydate_text" [(ttModel)]="get.deliverydate_text" (ttModelChange)="onCommonChange($event, 'deliverydate_text')"></tt-input>
        <tt-date *ngIf="get.setting_show_ph_head_deliverydate_confirmed !== '0'" ttLabel="deliverydate_confirmed" [(ttModel)]="get.deliverydate_confirmed" (ttModelChange)="onCommonChange($event, 'deliverydate_confirmed')" ttAllowEmpty></tt-date>
        <tt-checkbox *ngIf="get.setting_show_ph_head_isconfirmed !== '0'" ttLabel="isconfirmed" [(ttModel)]="get.isconfirmed" (ttModelChange)="onCommonChange($event, 'isconfirmed')"></tt-checkbox>
        <tt-select *ngIf="get.setting_show_ph_head_deliveryterm_no !== '0'" ttLabel="deliveryterm_no" [(ttModel)]="get.deliveryterm_no" (ttModelChange)="onCommonChange($event, 'deliveryterm_no')" [ttData]="deliveryTerms"></tt-select>
        <tt-select *ngIf="get.setting_show_ph_head_deliverymethod_no !== '0'" ttLabel="deliverymethod_no" [(ttModel)]="get.deliverymethod_no" (ttModelChange)="onCommonChange($event, 'deliverymethod_no')" [ttData]="deliveryMethods"></tt-select>
    </ng-container>
</ng-template>

<ng-template #economy>
    <ng-container *ngIf="!!get">
        <tt-input *ngIf="get.setting_show_ph_head_order_valuta_id !== '0'" ttLabel="order_valuta_id" [ttModel]="get.order_valuta_id" ttReadonly></tt-input>
        <tt-input-number
            *ngIf="get.setting_show_ph_head_valuta_exchangerate_now !== '0'"
            ttLabel="valuta_exchangerate_now"
            [ttSublabel]="get.valuta_label"
            ttTranslateSublabel="false"
            [ttModel]="get.valuta_exchangerate_now"
            ttTextAlign="right"
            ttDecimals="6"
            ttFormatNumber
            ttReadonly
        >
            <ng-container buttons>
                <tt-form-field-button
                    *ngIf="get.show_goto_currency === '1'"
                    ttId="list"
                    ttIcon="fas fa-bars"
                    ttGoto="currencyexrates"
                    [ttGotoParms]="{ valuta_id: get.basecurrency_id, currencytype_keyno: '1' }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_currencyexrates"
                ></tt-form-field-button>
            </ng-container>
        </tt-input-number>

        <tt-checkbox *ngIf="get.setting_show_ph_head_exchangerate_locked !== '0'" ttLabel="exchangerate_locked" [(ttModel)]="get.exchangerate_locked" (ttModelChange)="onCommonChange($event, 'exchangerate_locked')"></tt-checkbox>

        <div [hidden]="get.exchangerate_locked === '0'">
            <tt-input-number
                *ngIf="get.setting_show_ph_head_valuta_exchangerate_locked !== '0'"
                ttLabel="valuta_exchangerate_locked"
                [ttSublabel]="get.valuta_label"
                ttTranslateSublabel="false"
                [(ttModel)]="get.valuta_exchangerate_locked"
                (ttModelChange)="onValutaExchangeRateLockedChanged()"
                ttTextAlign="right"
                ttDecimals="6"
                ttFormatNumber
            ></tt-input-number>
            <tt-input *ngIf="get.setting_show_ph_head_order_valuta_pr !== '0'" ttLabel="order_valuta_pr" [ttModel]="get.order_valuta_pr" ttReadonly></tt-input>
            <tt-input-number *ngIf="get.setting_show_ph_head_valuta_exchangefactor_locked !== '0'" ttLabel="valuta_exchangefactor_locked" [ttModel]="get.valuta_exchangefactor_locked" ttTextAlign="right" ttDecimals="6" ttFormatNumber ttReadonly></tt-input-number>
        </div>
        <tt-select
            *ngIf="get.setting_show_ph_head_pricelist_id !== '0'"
            ttLabel="purchase_pricelist"
            [(ttModel)]="get.pricelist_id"
            (ttModelChange)="onCommonChange($event, 'pricelist_id')"
            [ttData]="pricelists"
            [ttShowClearButton]="get.pricelist_id > ''"
        ></tt-select>
    </ng-container>
</ng-template>

<ng-template #admin>
    <ng-container *ngIf="!!get">
        <tt-input *ngIf="get.setting_show_ph_head_businessco_companyname !== '0'" ttLabel="businessco_companyname" [ttModel]="get.businessco_companyname" ttReadonly></tt-input>
        <tt-input *ngIf="get.setting_show_ph_head_stockplace_id !== '0' && get.change_stokcplace_id_is_possible === '0'" ttLabel="stockplace" [ttModel]="get.stockplace_name" ttReadonly></tt-input>
        <tt-select
            *ngIf="get.setting_show_ph_head_stockplace_id !== '0' && get.change_stokcplace_id_is_possible === '1'"
            ttLabel="stockplace"
            [(ttModel)]="get.stokcplace_id"
            (ttModelChange)="onCommonChange($event, 'stokcplace_id')"
            [ttData]="stockplaces"
            ttDataId="stockplace_id"
            ttDataName="stockplace_name"
        ></tt-select>
        <tt-select *ngIf="get.setting_show_ph_head_purchasestatus_id !== '0'" ttLabel="purchasestatus" [ttModel]="get.purchasestatus_id" [ttData]="purchaseStatuses" ttDataId="purchasestatus_id" ttDataName="purchasestatus_name" ttReadonly></tt-select>
        <tt-button
            *ngIf="get.show_purchhead_cancel_rest === '1'"
            ttText="purchhead_cancel_rest"
            ttType="danger"
            ttIcon="fas fa-sync-alt"
            (ttClick)="cancelRest()"
            [ttLoading]="cancellingRest"
        ></tt-button>
        <tt-select *ngIf="get.setting_show_ph_head_portal_user_keyno !== '0'" ttLabel="purchaser" [(ttModel)]="get.portal_user_keyno" (ttModelChange)="onCommonChange($event, 'portal_user_keyno')" [ttData]="portalUsers"></tt-select>
        <tt-select
            *ngIf="get.setting_show_ph_head_portal_user_keyno_initiated_by !== '0'"
            ttLabel="portal_user_keyno_initiated_by"
            [(ttModel)]="get.portal_user_keyno_initiated_by"
            (ttModelChange)="onCommonChange($event, 'portal_user_keyno_initiated_by')"
            [ttData]="initiatedByList"
        ></tt-select>
        <tt-input *ngIf="get.setting_show_ph_head_user_id !== '0' && get.portal_user_keyno === '0'" ttLabel="user_id" [ttModel]="get.user_id" ttReadonly></tt-input>
        <tt-input *ngIf="get.setting_show_ph_head_purch_order_no !== '0'" ttLabel="purch_order_no" [ttModel]="get.purch_order_no" ttReadonly></tt-input>
        <tt-input *ngIf="get.setting_show_ph_head_order_order_no !== '0' && get.order_internal_no > '0'" ttLabel="order_order_no" [ttModel]="get.order_order_no" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button
                    ttId="goto"
                    ttIcon="fas fa-chevron-right"
                    ttGoto="orderhead"
                    [ttGotoParms]="{ order_internal_no: '' + get.order_internal_no }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_orderhead"
                ></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-date *ngIf="get.setting_show_ph_head_order_date !== '0'" ttLabel="order_date" [(ttModel)]="get.order_date" (ttModelChange)="onCommonChange($event, 'order_date')" ttAllowEmpty></tt-date>
        <tt-input *ngIf="get.setting_show_ph_head_our_ref !== '0'" ttLabel="our_ref" [(ttModel)]="get.our_ref" (ttModelChange)="onCommonChange($event, 'our_ref')"></tt-input>
        <tt-input *ngIf="get.setting_show_ph_head_tracktrace_url !== '0'" ttLabel="tracktrace_url" [(ttModel)]="get.tracktrace_url" (ttModelChange)="onCommonChange($event, 'tracktrace_url')">
            <ng-container buttons>
                <tt-form-field-button
                    *ngIf="get.tracktrace_url > ''"
                    ttId="goto"
                    ttIcon="fas fa-link"
                    (ttClick)="openTrackTraceUrl()"
                    [ttTranslateTooltip]="true"
                    ttTooltip="open_tracking"
                ></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-input *ngIf="get.setting_show_ph_head_consernorder_order_no !== '0' && get.consernorder_order_no > '0'" ttLabel="consernorder_order_no_factory" [ttModel]="get.consernorder_order_no" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button
                    ttId="goto"
                    ttIcon="fas fa-chevron"
                    ttGoto="orderhead"
                    [ttGotoParms]="{ order_internal_no: '' + get.consernorder_internal_no }"
                    [ttTranslateTooltip]="true"
                    ttTooltip="goto_orderhead"
                ></tt-form-field-button>
            </ng-container>
        </tt-input>
        <ng-container *ngIf="get.show_purchorder_to_salesorder === '1'">
            <tt-button ttText="purchhead_purchorder_to_salesorder" ttIcon="fas fa-sync-alt" (ttClick)="convertToSalesOrder()" [ttLoading]="convertingToSalesOrder"></tt-button>
            <tt-toast
                *ngIf="get.show_progress_text_purchorder_to_salesorder === '1'"
                class="col-xs-12 sp-0"
                ttType="danger"
                [ttTitle]="get.progress_text_purchorder_to_salesorder"
                ttTranslateTitle="false"
            ></tt-toast>
        </ng-container>
    </ng-container>
</ng-template>
